<template>
  <div class="thankyouPage page">
    
    <div class="columns">
      <div class="column">
        <div v-if="signedupUser">
          <h1>Ihr neuer Klinker App-Account</h1>
          <p>Hallo {{signedupUser.firstname}},</p>
          <p>vielen Dank für Ihr Interesse. <br>
            Sie erhalten nun eine E-Mail an Ihre E-Mail-Adresse {{signedupUser.email}}. <br>
            Bitte klicken Sie darin den Bestätigungslink an.</p>
          <p>Im Anschluss können Sie sich einloggen und die App in vollen Umfang benutzen.</p>
          
          <p>Falls Sie Fragen haben zur Klinker App oder deren Bedienung, bitte melden Sie sich.<br>
            Wir helfen gern, freuen uns über jedes Feedback und jeden Verbesserungsvorschlag.</p>
          <p>Viel Erfolg!<br>
            Ihr Team von köhler.</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'ThankyouPage',
    data: function(){
      return {
         }
    },
    created: function(){
    },
    mounted: function(){},
    computed: {
       signedupUser () {
            return this.$store.state.authentication.signedupUser
        },  
    }
}
</script>
<style>
</style>